// Generated by scripts/mdi/import-questionnaires.mjs from MDI "2. Tirzepatide + B6 Initial 09.17.26" (68f1d4e3-b4db-4ba0-865c-5946431de5ba). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiTirzepatideB6InitialAnswerField } from './questions';

export const mdiTirzepatideB6Initial: FormType<mdiTirzepatideB6InitialAnswerField> =
  {
    name: 'Tirzepatide + B6 Initial',
    validityLength: 25,
    questions: [
      {
        key: 'mdiTirzepatideB6Initial_state',
        next: {
          switch: [
            {
              condition: { 'mdiTirzepatideB6Initial_state.ms': true },
              key: 'mdiTirzepatideB6Initial_considerTreatmentGlp1AppropriateReasons'
            },
            {
              condition: { 'mdiTirzepatideB6Initial_state.la': true },
              key: 'mdiTirzepatideB6Initial_considerTreatmentGlp1AppropriateReasons'
            }
          ],
          els: 'mdiTirzepatideB6Initial_takingPrescriptionMedications'
        }
      },
      'mdiTirzepatideB6Initial_considerTreatmentGlp1AppropriateReasons',
      {
        key: 'mdiTirzepatideB6Initial_takingPrescriptionMedications',
        next: {
          switch: [
            {
              condition: {
                'mdiTirzepatideB6Initial_takingPrescriptionMedications.other_drug_not_listed':
                  true
              },
              key: 'mdiTirzepatideB6Initial_otherMedicationTaking'
            },
            {
              condition: {
                'mdiTirzepatideB6Initial_takingPrescriptionMedications.compounded_semaglutide':
                  true
              },
              key: 'mdiTirzepatideB6Initial_typeDrugInformationFoundLabel'
            },
            {
              condition: {
                'mdiTirzepatideB6Initial_takingPrescriptionMedications.compounded_tirzepatide':
                  true
              },
              key: 'mdiTirzepatideB6Initial_typeDrugInformationFoundLabel'
            },
            {
              condition: {
                'mdiTirzepatideB6Initial_takingPrescriptionMedications.wegovy_zepbound_mounjaro_ozempic_trulici':
                  true
              },
              key: 'mdiTirzepatideB6Initial_typeDrugInformationFoundLabel'
            }
          ],
          els: 'mdiTirzepatideB6Initial_labTestsCompletedWithinLast'
        }
      },
      {
        key: 'mdiTirzepatideB6Initial_otherMedicationTaking',
        next: {
          switch: [
            {
              condition: {
                'mdiTirzepatideB6Initial_takingPrescriptionMedications.compounded_semaglutide':
                  true
              },
              key: 'mdiTirzepatideB6Initial_typeDrugInformationFoundLabel'
            },
            {
              condition: {
                'mdiTirzepatideB6Initial_takingPrescriptionMedications.compounded_tirzepatide':
                  true
              },
              key: 'mdiTirzepatideB6Initial_typeDrugInformationFoundLabel'
            },
            {
              condition: {
                'mdiTirzepatideB6Initial_takingPrescriptionMedications.wegovy_zepbound_mounjaro_ozempic_trulici':
                  true
              },
              key: 'mdiTirzepatideB6Initial_typeDrugInformationFoundLabel'
            },
            {
              condition: {
                'mdiTirzepatideB6Initial_takingPrescriptionMedications.other_drug_not_listed':
                  true
              },
              key: 'mdiTirzepatideB6Initial_takePictureCurrentPrescriptionMedication'
            }
          ],
          els: 'mdiTirzepatideB6Initial_labTestsCompletedWithinLast'
        }
      },
      {
        key: 'mdiTirzepatideB6Initial_typeDrugInformationFoundLabel',
        next: {
          switch: [
            {
              condition: {
                'mdiTirzepatideB6Initial_takingPrescriptionMedications.compounded_semaglutide':
                  true
              },
              key: 'mdiTirzepatideB6Initial_takePictureCurrentPrescriptionMedication'
            },
            {
              condition: {
                'mdiTirzepatideB6Initial_takingPrescriptionMedications.compounded_tirzepatide':
                  true
              },
              key: 'mdiTirzepatideB6Initial_takePictureCurrentPrescriptionMedication'
            },
            {
              condition: {
                'mdiTirzepatideB6Initial_takingPrescriptionMedications.wegovy_zepbound_mounjaro_ozempic_trulici':
                  true
              },
              key: 'mdiTirzepatideB6Initial_takePictureCurrentPrescriptionMedication'
            },
            {
              condition: {
                'mdiTirzepatideB6Initial_takingPrescriptionMedications.other_drug_not_listed':
                  true
              },
              key: 'mdiTirzepatideB6Initial_takePictureCurrentPrescriptionMedication'
            }
          ],
          els: 'mdiTirzepatideB6Initial_labTestsCompletedWithinLast'
        }
      },
      {
        key: 'mdiTirzepatideB6Initial_takePictureCurrentPrescriptionMedication',
        next: {
          switch: [
            {
              condition: {
                'mdiTirzepatideB6Initial_takingPrescriptionMedications.wegovy_zepbound_mounjaro_ozempic_trulici':
                  true
              },
              key: 'mdiTirzepatideB6Initial_dateLastDose'
            },
            {
              condition: {
                'mdiTirzepatideB6Initial_takingPrescriptionMedications.compounded_semaglutide':
                  true
              },
              key: 'mdiTirzepatideB6Initial_dateLastDose'
            },
            {
              condition: {
                'mdiTirzepatideB6Initial_takingPrescriptionMedications.compounded_tirzepatide':
                  true
              },
              key: 'mdiTirzepatideB6Initial_dateLastDose'
            },
            {
              condition: {
                'mdiTirzepatideB6Initial_takingPrescriptionMedications.other_drug_not_listed':
                  true
              },
              key: 'mdiTirzepatideB6Initial_dateLastDose'
            }
          ],
          els: 'mdiTirzepatideB6Initial_labTestsCompletedWithinLast'
        }
      },
      'mdiTirzepatideB6Initial_dateLastDose',
      {
        key: 'mdiTirzepatideB6Initial_labTestsCompletedWithinLast',
        next: {
          condition: {
            'mdiTirzepatideB6Initial_labTestsCompletedWithinLast.yes': true
          },
          key: 'mdiTirzepatideB6Initial_doctorOnlyNeedsSeeCholesterol',
          els: 'mdiTirzepatideB6Initial_highCholesterol'
        }
      },
      'mdiTirzepatideB6Initial_doctorOnlyNeedsSeeCholesterol',
      'mdiTirzepatideB6Initial_highCholesterol',
      'mdiTirzepatideB6Initial_chronicPancreatitisPrevious',
      'mdiTirzepatideB6Initial_historyKidneyFailure',
      'mdiTirzepatideB6Initial_likePrescriptionNauseaMedicationSent',
      'mdiTirzepatideB6Initial_readInformationAboutPersonalizedTreatment',
      'mdiTirzepatideB6Initial_importantClickAttachedLinkReview',
      'mdiTirzepatideB6Initial_heresFirstMessageDoctorIntroduce',
      'mdiTirzepatideB6Initial_complete'
    ]
  };
